// extracted by mini-css-extract-plugin
export default {"row":"CRStep6_row__KYwoA","labels__row":"CRStep6_labels__row__ztjC0","input__value":"CRStep6_input__value__4O19n","trash":"CRStep6_trash__FtwBn"};